import { render, staticRenderFns } from "./componentCorrect.vue?vue&type=template&id=632c9b86&scoped=true"
import script from "./componentCorrect.vue?vue&type=script&lang=js"
export * from "./componentCorrect.vue?vue&type=script&lang=js"
import style0 from "./componentCorrect.vue?vue&type=style&index=0&id=632c9b86&lang=scss"
import style1 from "./componentCorrect.vue?vue&type=style&index=1&id=632c9b86&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c9b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632c9b86')) {
      api.createRecord('632c9b86', component.options)
    } else {
      api.reload('632c9b86', component.options)
    }
    module.hot.accept("./componentCorrect.vue?vue&type=template&id=632c9b86&scoped=true", function () {
      api.rerender('632c9b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/componentCorrect.vue"
export default component.exports